module.exports = __webpack_public_path__ + "img/help.6189ee66.png";